import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import LinkInput from '../link/LinkInput';
import { LINK_ENTITY_TYPE } from '../../constants/linkConstants';
import { useEditorContext } from '../../logic/EditorContext';
import AccurityIcon from '../../../icon/components/AccurityIcon';
var LinkControls = function () {
    var _a = useState(false), showUrlInput = _a[0], setShowUrlInput = _a[1];
    var _b = useState(''), urlValue = _b[0], setUrlValue = _b[1];
    var _c = useEditorContext(), contentHelper = _c[1], linksHelper = _c[2];
    var handleConfirmLink = function () {
        setShowUrlInput(false);
        setUrlValue('');
        linksHelper.addLink(urlValue);
    };
    var handleRemoveLink = function (event) {
        event.preventDefault();
        linksHelper.clearLink();
    };
    var handlePromptForLink = function (event) {
        event.preventDefault();
        linksHelper.showLinkPrompt(setUrlValue, setShowUrlInput);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(LinkInput, { urlValue: urlValue, setUrlValue: setUrlValue, showUrlInput: showUrlInput, setShowUrlInput: setShowUrlInput, confirmLink: handleConfirmLink }),
        contentHelper.entityTypeAtSelection === LINK_ENTITY_TYPE ?
            React.createElement(Tooltip, { title: "Remove link" },
                React.createElement(AccurityIcon, { iconName: "mui:LinkOff", className: "RichEditor-singleControl", onMouseDown: handleRemoveLink, fontSize: "small" })) :
            React.createElement(Tooltip, { title: "Add link" },
                React.createElement(AccurityIcon, { iconName: "mui:Link", className: "RichEditor-singleControl", color: "disabled", onMouseDown: handlePromptForLink, fontSize: "small" }))));
};
export default LinkControls;
//# sourceMappingURL=LinkControls.js.map